import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaOrderLaundryReceptionTypeClotheOperation} from '../../../../../../../../util/validationLavanderia'
import {SelectModel, TypeClothe} from '../../../../../../model'
import {
  createReceptionByLaundryOperation,
  updateReceptionByLaundryOperation,
} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {SelectWrapper} from '../../../../../../../../components/UI/Form/Input'
import {InputText, InputNumberDecimal} from '../../../../../../../../components/UI/Input'
import {useTableMaster} from '../../../../../../hooks'
import {ModalComponent} from '../../../../../../../../components/Layout/Modal'
import {
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
  ERROR_MESSAGE_SYSTEM,
} from '../../../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import {useModules} from '../../../../../../../hoteleria/hooks/useModules'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getReceptionByLaundryOperationList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: any
  addFunction?: (e: any) => void
  campamentoId?: string
}

const ModalAddFurniture: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getReceptionByLaundryOperationList,
  idPermission,
  detailpermission,
  campamentoId,
}) => {
  const {currentTabItem} = useLavanderia()
  const {getModulesLav} = useModules()
  const {
    originLaundry,
    getOriginLaundryList,
    bedClotheOperation,
    getBedClotheOperationList,
    nivel,
    getNivelList,
  } = useTableMaster()
  const [loadingAddFurniture, setLoadingAddFurniture] = useState<boolean>(false)
  const [isBack, setBack] = useState<boolean | any>(null)
  const [modules, setModules] = useState<SelectModel[]>([])
  const [pisos, setPisos] = useState<SelectModel[]>([])
  const methods = useForm<TypeClothe>({
    resolver: yupResolver(schemaOrderLaundryReceptionTypeClotheOperation),
  })
  const {
    setValue,
    handleSubmit,
    register,
    formState: {errors},
  } = methods
  useEffect(() => {
    if (idPermission) {
      setValue('tipoRopa', detailpermission?.tipoRopa.trim())
      setValue('cantidad', detailpermission?.cantidad)
      setValue('peso', detailpermission?.peso)
      setValue('observaciones', detailpermission?.observaciones)
      setValue('origen', detailpermission?.origen)
      setValue('ModuloId', detailpermission?.moduloId)
      setValue('PisoId', detailpermission?.pisoId)
      setValue('estado', detailpermission?.estado)
    }
  }, [idPermission])

  const getModulesFn = async () => {
    const data = await getModulesLav({CampamentoId: campamentoId})

    setModules(data)
  }
  useEffect(() => {
    getModulesFn()
  }, [campamentoId])
  useEffect(() => {
    getBedClotheOperationList()
    getOriginLaundryList()
    getNivelList()
  }, [])

  const handleClose = () => {
    setShow(false)
    setIdPermissionList()
    setValue('tipoRopa', '')
    setValue('cantidad', '')
    setValue('observaciones', '')
    setValue('origen', '')
    setValue('estado', '')
    setBack(false)
    setPisos([])
    setValue('peso', '')
    setValue('ModuloId', '')
    setValue('PisoId', '')
  }
  const handleReset = () => {
    setValue('peso', '')
    setValue('ModuloId', '')
    setValue('PisoId', '')
  }
  const onSubmit = async (data: TypeClothe) => {
    try {
      let obj = {
        ordenId: currentTabItem.idToEdit,
        detalle: data,
      }
      let objE = {
        ordenId: currentTabItem.idToEdit,
        detalle: {
          id: idPermission,
          ...data,
        },
      }
      setLoadingAddFurniture(true)
      let isCreating = !idPermission
      const response = isCreating
        ? await createReceptionByLaundryOperation(obj)
        : await updateReceptionByLaundryOperation(objE)
      const message = !idPermission ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
      if (!response.data.error) {
        ShowSnackBar(message)
        if (!isBack) {
          handleClose()
        }
        handleReset()
        getReceptionByLaundryOperationList()
        setLoadingAddFurniture(false)
      } else {
        ShowSnackBar(response.data.message, 'error')
        setLoadingAddFurniture(false)
      }
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
      setLoadingAddFurniture(false)
    }
  }

  let title = idPermission ? 'Editar Ropa' : 'Agregar Ropa'
  const handleChangeSelect = (e: any) => {
    setBack(e.target.checked)
  }

  const handleGetModule = (e: any) => {
    const array = Array.from({length: e.NroPisos}, (_, i) => i + 1)
    const filteredArray = nivel.filter((item) => array.includes(Number(item.codigo)))
    setPisos(filteredArray)
  }
  return (
    <ModalComponent
      show={show}
      handleClose={handleClose}
      size='lg'
      title={title}
      handleSubmit={handleSubmit(onSubmit)}
      disabledSubmit={loadingAddFurniture}
    >
      <FormProvider {...methods}>
        <form>
          <div className='row'>
            <div className='mb-2 col-6'>
              <SelectWrapper
                labelText='Tipo de ropa'
                name='tipoRopa'
                data={bedClotheOperation}
                required
              />
            </div>
            <div className='col-sm-12 col-lg-6'>
              <label>Cantidad:</label>
              <InputNumberDecimal
                name='cantidad'
                textPlaceholder='Escribe la cantidad'
                register={register}
                errors={errors}
              />
            </div>
            <div className='col-sm-12 col-lg-6'>
              <label className='required'>Peso KG:</label>
              <InputNumberDecimal
                name='peso'
                textPlaceholder='Escribe el peso'
                register={register}
                errors={errors}
              />
            </div>
            <div className='mb-2 col-6'>
              <SelectWrapper labelText='Origen' name='origen' data={originLaundry} required />
            </div>
            <div className='mb-2 col-6'>
              <SelectWrapper
                labelText='Módulo Origen'
                name='ModuloId'
                data={modules}
                required
                onChangeValue={handleGetModule}
              />
            </div>
            <div className='mb-2 col-6'>
              <SelectWrapper labelText='Piso de Origen' name='PisoId' data={pisos} required />
            </div>
            <div className='col-sm-12 col-lg-6'>
              <label>Observaciones:</label>
              <InputText
                name='observaciones'
                textPlaceholder='Escribe la observación'
                register={register}
                errors={errors}
                Uppercase={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-lg-6 d-flex align-items-center'>
              <div className='form-check form-check-custom form-check-solid pe-2'>
                <input
                  className='form-check-input border border-gray-500'
                  type='checkbox'
                  data-kt-check={isBack}
                  data-kt-check-target='#kt_table_users .form-check-input'
                  checked={isBack}
                  onChange={handleChangeSelect}
                />
              </div>
              <label className='me-2'>Volver agregar</label>
            </div>
          </div>
        </form>
      </FormProvider>
    </ModalComponent>
  )
}

export {ModalAddFurniture}
